import React from 'react'
import Box from '@mui/material/Box'
import ButtonBase from '@mui/material/ButtonBase'
import Brand from '@components/common/Brand'

type DashboardHeaderProps = {
  fullScreen?: boolean
  onTitleClick?: () => void
  mainColor: string
  mainColorDarker: string
  altColor: string
  altColorDarker: string
  children?: React.ReactNode
}

export default function DashboardHeader({
  fullScreen,
  onTitleClick,
  children,
}: DashboardHeaderProps): JSX.Element {
  return (
    <Box
      component="header"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={1}
      sx={{ minHeight: { xs: 52, md: 60 }, pt: 1, pb: 0, mb: '12px', px: { xs: 0.5, sm: 1 } }}
    >
      <ButtonBase onClick={onTitleClick} aria-label="RankTrivia home" sx={{ borderRadius: '16px' }}>
        <Brand compact={fullScreen} />
      </ButtonBase>
      <Box display="flex" alignItems="center" gap={0.5}>
        {children}
      </Box>
    </Box>
  )
}
